/**
 * CRM user designations / job titles
 */

export const USER_DESIGNATIONS = {
    sales_executive: 'Sales Executive',
    team_lead: 'Team Lead',
    manager: 'Manager',
    director: 'Director',
    vp: 'VP',
    specialist: 'Specialist',
    analyst: 'Analyst',
    engineer: 'Engineer',
    consultant: 'Consultant'
};

export const USER_DESIGNATION_ORDER = Object.keys(USER_DESIGNATIONS);
